import { List, ListItem, styled, Typography } from '@mui/material';
import React from 'react';

const StyledListItem = styled(ListItem)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  paddingTop: '0',
  paddingBottom: '10px',
});

const FeatureHighlights: React.FC = () => {
  return (
    <>
      <Typography
        variant="subtitle2"
        sx={{
          height: '20px',
          color: '#0047FF',
          margin: 0,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        FEATURE HIGHLIGHTS
      </Typography>
      <div style={{ height: 'inherit' }}>
        <List sx={{ height: 'inherit', marginTop: '10px', paddingTop: '0', paddingBottom: '0' }}>
          <StyledListItem>
            <Typography variant="body2">
              <b>🚀 GPT-4o Search Preview Is Now Live</b>
            </Typography>
            <Typography variant="body2">
              Optimized for fast, accurate real-time web searches and market research, this model is
              not intended for file uploads or image processing. For best results, use it
              exclusively for web-based queries.
            </Typography>
          </StyledListItem>
          <StyledListItem>
            <Typography variant="body2">
              <b>🚀 GPT-4.1 Is Now Live</b>
            </Typography>
            <Typography variant="body2">
              Designed for complex problem solving, it delivers more reliable code generation,
              improved instruction following, and enhanced long-context processing. Perfect for
              tackling cross-domain tasks with greater speed and precision.
            </Typography>
          </StyledListItem>
        </List>
      </div>
    </>
  );
};

export default FeatureHighlights;
